<template>
  <DefaultLayout
      :pageClass="this.currentStep === '4' || this.currentStep === '5' ? 'puzzleWheelPage': (this.currentStep === '1' ? 'formPage': 'defaultPage')">
    <component
        :is="currentComponent"
        :user-info="userInfo"
        :answers="answers"
        @update-answers="updateAnswers"
        @update-user-info="updateUserInfo"
        @submit-user-info="submitUserInfo"
        @next-step="nextStep"
        @prev-step="prevStep"
        @return-home="returnHome"
    />
  </DefaultLayout>
</template>

<script>
import Step1 from './components/form-page.vue';
import Step2 from './components/questions-page.vue';
import Step3 from './components/question-sec-page.vue';
import Step4 from './components/puzzle-page.vue';
import Step5 from './components/wheel-spinner-page.vue';

export default {
  components: {
    Step1,
    Step2,
    Step3,
    Step4,
    Step5
  },
  data() {
    return {
      currentStep: 1, // Tracks the current step
      userInfo: {
        fname: '',
        lname: '',
        email: '',
        acceptGdpr: false,
      },
      answers: {
        question1: '',
        question2: '',
      },
    };
  },
  computed: {
    currentComponent() {
      // Map the current step to its corresponding component
      return `Step${this.currentStep}`;
    },
  },
  methods: {
    updateAnswers(newAnswers) {
      this.answers = {...this.answers, ...newAnswers};
    },
    updateUserInfo(newUserInfo) {
      this.userInfo = newUserInfo;
    },
    submitUserInfo() {
      if (this.currentStep < 5) {
        this.currentStep++;
      }
      console.log("Form Data Submitted:", this.userInfo);
    },
    nextStep() {
      if (this.currentStep < 5) {
        this.currentStep++;
        window.scrollTo(0, 0);
      }
    },
    prevStep() {
      if (this.currentStep > 1) {
        this.currentStep--;
        window.scrollTo(0, 0);
      }
    },
    returnHome() {
      this.currentStep = 1;
      this.userInfo = {
        fname: '',
        lname: '',
        email: '',
        acceptGdpr: false,
      };
      this.answers = {
        question1: '',
        question2: '',
      };
      window.scrollTo(0, 0);
    }
  },
};
</script>
